import { assertNever } from 'owa-assert';
import type { ProjectId, AssetId, TimeStreamAsset } from '../schema';
import getStore from '../store';
import getAsset from './getAsset';

export default function getMultipleAssets(projectId: ProjectId, assetIds: AssetId[]) {
    const assets: (TimeStreamAsset | null)[] = [];

    const projectSummary = getStore().projects.get(projectId);
    if (!projectSummary) {
        return assertNever('unknown project' as never);
    }

    assetIds.forEach(assetId => {
        const asset = getAsset(projectId, assetId);
        !!asset ? assets.push(asset) : assets.push(null);
    });
    return assets.length > 0 ? assets : assertNever('unknown asset' as never);
}
